import Icon from "components/Common/Icon";
import { formatEnchantName, getEnchantImgSrc, getEnchantQualityIconSrc } from "lib/enchant-display";
import EnchantTooltip from "../Tooltips/EnchantTooltip";
import React from "react";
import WowTooltip from "../Tooltips/WowTooltip";
import CraftedIcons from "./CraftedIcons";
import GemIcons from "./GemIcons";

const WeaponItem = (props) => {
  const {
    enchantName,
    enchantId,
    enchantItemId,
    enchantDisplayName,
    enchantQuality,
    itemName,
    itemColor,
    img,
    id,
    positionLeft,
    popularity,
    count,
    bonusIds,
    embellishmentItemIds,
    missiveItemId,
    craftingQuality,
    gems,
  } = props;

  return (
    <div>
      <div className={`weapon-container ${!positionLeft ? "right-container" : ""}`}>
        <div className="weapon-item-container">
          <WowTooltip type="item" id={id} bonusIds={bonusIds} craftingQuality={craftingQuality} enchant={enchantId} gems={gems}>
            <Icon staticDataImg={img} classType="bis-item-icon" color={itemColor} />
          </WowTooltip>
          <div className="item-info">
            <div className="item-name" style={{ color: itemColor }}>
              {itemName}
            </div>
            <div className="enchant-info">
              <GemIcons gems={gems} />
              <CraftedIcons embellishmentItemIds={embellishmentItemIds} missiveItemId={missiveItemId} />
              {enchantName ? (
                <EnchantTooltip itemId={enchantItemId}>
                  <Icon iconSize="18px" staticDataImg={getEnchantImgSrc(enchantItemId)} />
                </EnchantTooltip>
              ) : null}
              <div className="enchant-text">{formatEnchantName(enchantName, enchantDisplayName)}</div>
              {enchantName ? (
                <img
                  style={
                    enchantQuality == 2
                      ? { width: "16px", height: "8px", marginLeft: "4px" }
                      : { width: "16px", height: "12px", marginLeft: "4px" }
                  }
                  src={getEnchantQualityIconSrc(enchantQuality)}
                ></img>
              ) : null}
            </div>
          </div>
        </div>
        {popularity ? (
          <div className="popularity-container">
            <div className="popularity-value">{parseFloat(popularity).toFixed(1)}%</div>
            <div className="popularity-label">({count.toLocaleString("en-US")} players)</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default WeaponItem;
